module.exports = __webpack_public_path__ + "media/hph-24-05_impact.87e2cbe9.mp4";